import { render, staticRenderFns } from "./PDFMaterial.vue?vue&type=template&id=a342934a&scoped=true&"
import script from "./PDFMaterial.vue?vue&type=script&lang=js&"
export * from "./PDFMaterial.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/pc/pdf_material.css?vue&type=style&index=0&id=a342934a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a342934a",
  null
  
)

export default component.exports